var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/Map Pin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6568 5.45684C16.1458 3.87252 14.1368 3 12 3C9.86314 3 7.85413 3.87252 6.34313 5.45684C4.8321 7.04117 4 9.13044 4 11.3199C4 15.5959 7.78745 19.5088 11.177 21.7504C11.6802 22.0832 12.3197 22.0832 12.8229 21.7503C16.2076 19.5106 20 15.5905 20 11.3199C20 9.19877 19.1679 7.04117 17.6568 5.45684Z",
    stroke: "current",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11C14.5 12.3807 13.3807 13.5 12 13.5C10.6193 13.5 9.5 12.3807 9.5 11C9.5 9.61929 10.6193 8.5 12 8.5C13.3807 8.5 14.5 9.61929 14.5 11Z",
    stroke: "current",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.5d55532d391c42394d6a62012c3e1426.svg";
export { ForwardRef as ReactComponent };